const colors = require('tailwindcss/colors');

const screenHeights = {
	'1/4-screen': '25vh',
	'1/2-screen': '50vh',
	'4/6-screen': '66.666667vh',
	'3/4-screen': '75vh',
};

const sizeSpacings = {
	xs: '20rem',
	sm: '24rem',
	md: '28rem',
	lg: '32rem',
	xl: '36rem',
};

const sizeFractions = {
	'1/2': '50%',
	'1/3': '33.333333%',
	'2/3': '66.666667%',
	'1/4': '25%',
	'2/4': '50%',
	'3/4': '75%',
	'1/5': '20%',
	'2/5': '40%',
	'3/5': '60%',
	'4/5': '80%',
	'1/6': '16.666667%',
	'2/6': '33.333333%',
	'3/6': '50%',
	'4/6': '66.666667%',
	'5/6': '83.333333%',
};

module.exports = {
	important: false,           // !important should only be used as a last resort
	content: [
		'./resources/**/*.html',
		'./resources/**/*.php',
		'./resources/**/*.vue',
		'./resources/**/*.js',
		'./resources/**/*.yaml',
		'./content/**/*.md',
	],
	theme: {
		screens: {
			xs: '26rem',        // equals 416 px
			sm: '40rem',        // equals 640 px
			md: '48rem',        // equals 768 px
			lg: '64rem',        // equals 1024 px
			xl: '80rem',        // equals 1280 px
			'2xl': '96rem',     // equals 1536 px
		},
		colors: {
			transparent: 'transparent',
			current: 'currentColor',
			black: colors.black,
			white: colors.white,
			gray: colors.gray,
			red: colors.red,
			primary: '#00B1EB',
			'primary-dark': '#009BCE',
			'primary-light': '#CCEFFB',
			secondary: '#070940',
			tertiary: '#F4F4F4',
			'custom-green': '#053826',
			'custom-green-light': '#01af46',
		},
		fontFamily: {
			title: ['Space Grotesk', 'sans-serif'],
			subtitle: ['Space Grotesk', 'sans-serif'],
			paragraph: ['Poppins', 'sans-serif'],
		},
		extend: {
			spacing: {
				128: '32rem',
			},
			borderWidth: {
				1: '1px',
				3: '3px',
			},
			height: {
				...screenHeights,
			},
			minHeight: {
				...screenHeights,
				...sizeSpacings,
			},
			minWidth: {
				...sizeSpacings,
			},
			maxHeight: {
				...sizeFractions,
				...screenHeights
			},
			maxWidth: {
				...sizeFractions,
			},
			transitionTimingFunction: {
				DEFAULT: 'ease-in-out',
			},
			transitionDuration: {
				DEFAULT: '300ms',
			},
			boxShadow: {
				center: '0 0px 15px 3px rgb(44 62 80 / 10%), 0 0 6px 0 rgb(44 62 80 / 10%)',
				'center-wide': '0 0px 15px 3px rgb(44 62 80 / 10%), 0 0 13px 2px rgb(44 62 80 / 10%)',
				'dropdown': '0 6px 6px 0 rgb(44 62 80 / 10%), 0 7px 7px -5px rgb(44 62 80 / 10%)',
			},
		}
	},
	variants: {
		extend: {},
	},
	plugins: [],
};
